export enum Client {
  Unknown = 0,
  Mobile = 1,
  Portal = 2,
  EtherealMed = 3,
  PortalPatient = 4,
  Patient = 5
}
